import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { CurrencyType } from '@dealstack/shared/lib/generated';
import { z } from 'zod';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export enum CREATE_FUND_FORM {
	NAME = 'name',
	TARGET_NAME = 'target_name',
	CURRENCY = 'currency',
}

export const CreateFundShape = (tCommonForm: TranslateFunction<I18Namespaces.COMMON_FORM>) =>
	z.object({
		[CREATE_FUND_FORM.NAME]: z
			.string({
				message: tCommonForm('field_required'),
			})
			.trim()
			.min(1, tCommonForm('field_required')),
		[CREATE_FUND_FORM.TARGET_NAME]: z
			.string({ message: tCommonForm('field_required') })
			.trim()
			.min(1, tCommonForm('field_required')),
		[CREATE_FUND_FORM.CURRENCY]: z.nativeEnum(CurrencyType).optional(),
	});

export type CreateFundFormValues = z.infer<ReturnType<typeof CreateFundShape>>;
